import "./User.scss";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Input } from "antd";

import Swal from "sweetalert2";

import ApiService from "../../apis/ApiService_mall";
import { setLoading } from "../../redux/store/common/commonDuck";

import SignUpHeader from "./SignUpHeader";

const api = new ApiService();
const FindPasswordComponent = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [userValue, setUserValue] = useState({
		phone: "",
		phone_valid: "",
		password: "",
		password_valid: "",
	});

	const [phoneValid, setPhoneValid] = useState(false); // 인증번호 전송
	const [isPhoneValid, setIsPhoneValid] = useState(false); // 인증번호 확인

	const [passwordRegValid, setPasswordRegValid] = useState(false); // 비밀번호 대소문자,숫자,특수문자 true/false
	const [passwordCheckValid, setPasswordCheckValid] = useState(false); // 비밀번호 확인

	const [inputValid, setInputValid] = useState(false); // 전체 의동의

	useEffect(() => {
		window.scrollTo({ top: 0 });
	}, []);

	/**
	 * 회원 정보 받기
	 * @type {(function(*): void)|*}
	 */
	const handleInputUser = useCallback(
		(e) => {
			const { value, name } = e.target;
			if (name === "phone") {
				if (value.split("-").join("").length <= 11) {
					let phone = value.replace(/[^0-9]/g, "");
					setUserValue({
						...userValue,
						phone: phone,
					});
				}
			} else if (name === "phone_valid") {
				if (value.split("-").join("").length <= 6) {
					let phone_valid = value.replace(/[^0-9]/g, "");
					setUserValue({
						...userValue,
						phone_valid: phone_valid,
					});
				}
			} else if (name === "password") {
				let password = value;
				// 특수문자 / 문자 / 숫자 포함 형태의 8~16 자리 이내의 암호 정규식
				let regPass =
					/^.*(?=^.{8,16}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/;
				if (password.match(regPass)) {
					setPasswordRegValid(true);
				} else {
					setPasswordRegValid(false);
				}

				// 숫자, 문자, 특수문자만 입력 가능
				const regExp = /[^0-9a-zA-Z!@#$%^&+=]/g;
				if (regExp.test(value)) {
					password = value.replace(regExp, "");
				}
				setUserValue({
					...userValue,
					[name]: password,
				});

				const regPassword =
					/^(?=.*[A-Za-z])(?=.*\d)[a-zA-Z\\d`~!@#$%^&*()-_=+(?=.*\d)]{8,}$/;
				if (regPassword.test(e.target.value)) {
					if (!passwordRegValid) setPasswordRegValid(true);
				} else {
					if (passwordRegValid) setPasswordRegValid(false);
				}
			} else if (name === "password_valid") {
				setUserValue({
					...userValue,
					[name]: value,
				});
				if (userValue.password === value) {
					setPasswordCheckValid(true);
				} else {
					setPasswordCheckValid(false);
				}
			} else {
				setUserValue({
					...userValue,
					[name]: value,
				});
			}
		},
		[userValue]
	);

	/**
	 * step 2-1 : 휴대폰 인증
	 */
	const sendPhoneValid = async () => {
		let regPhone = /010-?([0-9]{4})-?([0-9]{4})$/;
		if (regPhone.test(userValue.phone)) {
			setIsLoading(true);

			if (userValue.phone === "01012345678") {
				setIsLoading(false);
			} else {
				let param = { phone: userValue.phone, is_user_valid: true };
				let res = await api.smsPhoneCertifySend(param);

				if (res.data.code === 200) {
					setPhoneValid(true);
					setIsLoading(false);
				} else {
					setIsLoading(false);

					Swal.fire({
						text: `해당 번호로 가입된 유저가 없습니다. 회원가입 하시겠습니까?`,
						// confirmButtonColor: "#212529",
					}).then((res) => {
						if (res.isConfirmed) {
							history.push(`/user/signup`);
						}
					});
				}
			}
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "휴대폰 번호를 정확하게 입력해주세요.",
				// confirmButtonColor: "#212529",
			});
		}
	};

	/**
	 * step 2-2: 휴대폰 인증번호 일치 확인
	 */
	const checkPhoneValid = async () => {
		const regPhone = /([0-9]{6})$/;
		if (regPhone.test(userValue.phone_valid)) {
			setIsLoading(true);

			let param = {
				phone: userValue.phone,
				sms_verify_code: userValue.phone_valid,
			};
			let res = await api.smsCertifyVerify(param);

			if (res.data.code === 200) {
				Swal.fire({
					customClass: "alert-custom",
					text: "인증번호가 일치합니다.",
					// confirmButtonColor: "#212529",
				});
				setIsPhoneValid(true);
				// setTabIndex(4);
				setIsLoading(false);
			} else {
				Swal.fire({
					customClass: "alert-custom",
					text: "인증번호가 일치하지 않습니다.",
					// confirmButtonColor: "#212529",
				});
				// setIsSmsValid(true);
				setIsLoading(false);
			}
			// }
			// }
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "휴대폰 번호를 정확하게 입력해주세요.",
				// confirmButtonColor: "#212529",
			});
		}
	};

	/**
	 * 입력 값 밸리데이션 -> signupValue 변할 때 마다 적용
	 */
	useEffect(() => {
		const { phone, password } = userValue;
		if (
			phone?.replaceAll("-", "").length !== 11 ||
			!phoneValid ||
			!isPhoneValid ||
			!passwordRegValid ||
			!passwordCheckValid
			// name.length === 0 ||
			// birthday.length === 0
		) {
			if (inputValid) {
				setInputValid(false);
			}
		} else {
			setInputValid(true);
		}
	}, [passwordRegValid, userValue]);

	/**
	 * 변경하기 버튼 클릭
	 */
	const handleSignupButton = () => {
		if (isPhoneValid && passwordCheckValid) {
			setIsLoading(true);
			const timer = setTimeout(() => {
				updatePassword();
			}, 100);
			return () => clearTimeout(timer);
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "필수 입력 항목을 모두 적어주세요.",
				// confirmButtonColor: "#212529",
			});
		}
	};

	/**
	 * 비밀번호 변경
	 */
	const updatePassword = async () => {
		setIsLoading(true);
		const regPassword =
			/^(?=.*[A-Za-z])(?=.*\d)[a-zA-Z\\d`~!@#$%^&*()-_=+(?=.*\d)]{8,}$/;
		if (regPassword.test(userValue.password) && !!passwordCheckValid) {
			let param = {
				phone: userValue.phone,
				password: userValue.password,
			};
			let res = await api.updatePhonePassword(param);

			if (res.data.code === 200) {
				Swal.fire({
					customClass: "alert-custom",
					text: "비밀번호가 성공적으로 변경되었습니다.",
					// confirmButtonColor: "#212529",
				}).then((res) => {
					setIsLoading(false);
					history.replace(`/login`);
				});
			} else {
				Swal.fire({
					customClass: "alert-custom",
					text: "일시적인 오류로 실패하였습니다. 다시 시도해주세요.",
					// confirmButtonColor: "#212529",
				});
				setIsLoading(false);
			}
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "8자리 이상 비밀번호를 입력해주세요. (최소 영문, 숫자 1개 이상 포함)",
				// confirmButtonColor: "#212529",
			});
			setIsLoading(false);
		}
	};

	return (
		<div className="main-wrap">
			{/* 모바일 헤더 추가 */}
			<SignUpHeader title={"비밀번호 찾기"} />
			<div className="max-width-apply">
				{/* 기본 정보 */}
				<div className={`signup-form-parents`}>
					<h1
						className={`main-title`}
						id={`main-title`}
						style={{ margin: 0, paddingBottom: "0.5em" }}
					>
						비밀번호 찾기
					</h1>
					<div className={`signup-component-list`}>
						<h2>가입한 휴대폰 번호 정보를 입력해주세요</h2>
					</div>

					<div className={`signup-form-wrap`}>
						<div
							className={`signup-form-item ${
								phoneValid ? "padding" : "divider"
							}`}
						>
							<label>휴대폰 번호</label>
							<div className={`input-div phone`}>
								<Input
									type={`text`}
									placeholder={`- 없이 입력해주세요.`}
									value={userValue.phone}
									name={"phone"}
									onChange={handleInputUser}
									pattern={`/d*`}
									disabled={isPhoneValid}
								/>
								<Button
									loading={isLoading}
									disabled={isPhoneValid}
									onClick={sendPhoneValid}
								>
									인증
								</Button>
							</div>
						</div>
						{phoneValid && (
							<div
								className={`signup-form-item divider`}
								style={{ paddingTop: 0 }}
							>
								<label>인증번호</label>
								<div className={`input-div phone`} style={{ width: "30%" }}>
									<Input
										type={`text`}
										placeholder={`- 없이 입력해주세요.`}
										value={userValue.phone_valid}
										name={"phone_valid"}
										onChange={handleInputUser}
										pattern={`/d*`}
										disabled={isPhoneValid}
									/>
									<Button
										loading={isLoading}
										disabled={isPhoneValid}
										onClick={checkPhoneValid}
									>
										인증완료
									</Button>
								</div>
							</div>
						)}
						{isPhoneValid && (
							<div className={`signup-form-item padding`}>
								<label>변경 비밀번호</label>
								<div className={`input-div`}>
									<Input
										type={`password`}
										placeholder={`8자리 이상 비밀번호를 입력해주세요. (최소 영문, 숫자 1개 이상 포함)`}
										value={userValue.password}
										name={"password"}
										onChange={handleInputUser}
										pattern={`/d*`}
										style={{
											borderColor:
												userValue.password?.length > 0 &&
												!passwordRegValid &&
												"red",
										}}
									/>
								</div>
							</div>
						)}
						{isPhoneValid && (
							<div className={`signup-form-item padding`}>
								<label>변경 비밀번호 확인</label>
								<div className={`input-div`}>
									<Input
										type={`password`}
										placeholder={``}
										value={userValue.password_valid}
										name={"password_valid"}
										onChange={handleInputUser}
										pattern={`/d*`}
										style={{
											borderColor:
												userValue.password_valid?.length > 0 &&
												!passwordCheckValid &&
												"red",
										}}
									/>
								</div>
							</div>
						)}
					</div>
				</div>

				{isPhoneValid && (
					<div className={`signup-blue-button-wrap`}>
						<Button
							loading={isLoading}
							className={`signup-blue-button`}
							onClick={handleSignupButton}
						>
							변경하기
						</Button>
					</div>
				)}
			</div>
		</div>
	);
};

export default FindPasswordComponent;
